import React, { useState, useEffect } from "react";
import { useNavigate , useParams} from 'react-router-dom';

export default function AdminAddStudentStep3() {
  const navigate = useNavigate();
  const {slug} = useParams();



  const handleSubmit = async (e) => {
    e.preventDefault();
    //console.log("slug",slug);
      navigate(`/admin/admin-studentdetail/${slug}`);
    }

  return (
            <div className="col-xl-12 col-md-12">
              <div className="settings-widget profile-details">
                <div className="settings-menu p-2">
                  <div className="profile-heading p2">
                    <h3>Add Student</h3>
                  </div>
                  <div className="checkout-form personal-address add-course-info ">
                    <form role="form" onSubmit={handleSubmit}>
                      <div className="row mx-auto">
                      <div className="add-course-msg">
                        <i className="fas fa-circle-check"></i>
                        <h4>The Student Added Succesfully</h4>
                        <p></p>
                      </div>

                        <div className="update-profile d-flex justify-content-between">
                          <button type="submit"  className="btn btn-primary">
                            Next Step  {">>"}
                          </button>
                          <button onClick={() => navigate(-1)} className="btn btn-black btn-sm">
                          Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
  );
}
